// Legacy BillingGroup serialization includes non camelcase properties
/* eslint-disable camelcase */
import Immutable from 'immutable'
import moment from 'moment'

export const BillingGroupRecord = Immutable.Record({
  abn: null,
  client_id: null,
  client_name_override: null,
  contact: null, // Stores user id, not full object
  date_added: null,
  date_updated: null,
  email_overrides: Immutable.Set(),
  guid: null,
  id: null,
  name: null,
  payment_token: null,
  serviceCount: 0,
  site: null, // Stores site id, not full object
  technical_emails: Immutable.Set(),
  term: null,
  token_required: null,
}, 'BillingGroup')

export default function createBillingGroup({
  contact,
  date_added,
  date_updated,
  email_overrides = [],
  serviceCount,
  site,
  technical_emails,
  term,
  ...data
}) {
  return new BillingGroupRecord({
    contact: contact ? contact.id : null,
    date_added: date_added ? moment(date_added) : null,
    date_updated: date_added ? moment(date_updated) : null,
    email_overrides: Immutable.Set(email_overrides),
    serviceCount: parseInt(serviceCount, 10),
    site: site ? site.id : null,
    technical_emails: Immutable.Set(technical_emails),
    term: term ? moment.duration(term) : null,
    ...data,
  })
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/BillingGroup.js